// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"DeskTags_skeleton__1s-xQ","root":"DeskTags_root__22Xdt","tag":"DeskTags_tag__3orLv"};